import { render, staticRenderFns } from "./EstablishSpecialty.vue?vue&type=template&id=33028ace&scoped=true&"
import script from "./EstablishSpecialty.vue?vue&type=script&lang=js&"
export * from "./EstablishSpecialty.vue?vue&type=script&lang=js&"
import style0 from "./EstablishSpecialty.vue?vue&type=style&index=0&id=33028ace&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33028ace",
  null
  
)

export default component.exports